import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Escola',
    path: '/administracao/escola',
    name: 'escola',
    component: () => import('@/views/administracao/escola/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DADOSDAESCOLANOVO_MENU_2200100099],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Escolas',
    path: '/administracao/escola/cadastro/:id?',
    parent: 'escola',
    name: 'escola_create',
    component: () => import('@/views/administracao/escola/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.DADOSDAESCOLANOVO_MENU_2200100099],
    },
  },
  {
    description: 'Etapas Letivas',
    path: '/administracao/escola/:codigoEscola/etapasletivas',
    parent: 'escola',
    name: 'etapasescola',
    component: () => import('@/views/administracao/escola/etapasletivas/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DADOSDAESCOLANOVO_MENU_2200100099],
    },
  },
  {
    description: 'Painel de Professores',
    path: '/administracao/painelprofessores',
    name: 'painel_professores',
    component: () => import('@/views/administracao/professores/Painel.vue'),
    meta: {

    },
    goesToMenu: true,
  },
]

